"use client";

import { ConversionShowcaseDesktop } from "@/app/(marketing)/components/demo/showcases/conversionShowcase/components/ConversionShowcaseDesktop";
import { ConversionShowcaseMobile } from "@/app/(marketing)/components/demo/showcases/conversionShowcase/components/ConversionShowcaseMobile";
import { useConversionShowcase } from "@/app/(marketing)/components/demo/showcases/conversionShowcase/hooks/useConversionShowcase";

export function ConversionShowcase() {
  const { outputAudioRef, inputAudioRef, ...layoutProps } =
    useConversionShowcase();

  return (
    <div className="rounded-3xl bg-gray-50 px-4 py-8 sm:px-10">
      <audio ref={outputAudioRef} preload="none" className="hidden" />
      <audio ref={inputAudioRef} preload="none" className="hidden" />

      <ConversionShowcaseMobile {...layoutProps} />
      <ConversionShowcaseDesktop {...layoutProps} />
    </div>
  );
}
